<div class="splash-screen" *ngIf="show">

  <div class="auth-wrapper" id="loginBackGround" >
    <div class="auth-content">
      <div class="card shadow p-3 mb-5 bg-white rounded">
        <div class="row align-items-center text-center">
          <div class="col-md-12">
            <div class="card-body">
              <img src="assets/images/IFSLogo.png" alt="" class="auth-logo mb-4">
              <h4 class="mb-3 f-w-400">Checking for updates</h4>
              <div class="spinner-border"  role="status"></div>

            </div>

          </div>

        </div>
      </div>
    </div>
  </div>



</div>
